'use strict';

import $ from 'jquery';
import videoControls from './video-controls';
import showAlerts from './alert';
import initTopAdBar from './top-ad-bar';
import mapEmbed from './map-embed';
import numberstepper from './numberstepper';
import tabs from './tabs';

export {
	mapEmbed,
	numberstepper
};

export default function(API) {
	$(document).ready(() => {

		API.log('INIT UI');

		videoControls('video[data-controls]');
		showAlerts('body .page');
		initTopAdBar(API)('.top-ad-bar');

		if (document.querySelector('.modal-link') || document.querySelector('.v4-checkout')) {
			import('./modal').then(({ default: modal }) => {
				modal('.modal-link');
			});
		}

		tabs('.content-tabs, .m-tabs');
	});
}
